import { PlayerSizesTypes } from '../../../common/store/store.types';
import { isEmpty } from '../../../common/utils/utils';
import { removeHighlights } from '../styles';

interface StylesObject {
  playButtonStyle: { [key: string]: any };
  pauseButtonStyle: { [key: string]: any };
  containerStyle: { [key: string]: any };
}

type DisplayButton = {
  extraSmallAndSmall: { [key: string]: any };
  medium: { [key: string]: any };
  largeAndExtraLarge: { [key: string]: any };
} & any;

type SplitViewDisplayButton = {
  left: string;
  extraSmallAndSmall: { [key: string]: any };
  medium: { [key: string]: any };
}

interface PlayPauseButtonStyleObject {
  root: any;
  displayButton: DisplayButton;
  splitViewDisplayButton: SplitViewDisplayButton;
}

const playPauseButton = (splitViewRatio: number): PlayPauseButtonStyleObject => ({
  root: {
    display: 'none',
    pointerEvents: 'none',
  },
  displayButton: {
    cursor: 'pointer',
    position: 'absolute',
    display: 'inline-block',
    pointerEvents: 'all',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '100%',
    backdropFilter: 'blur(3px)',
    extraSmallAndSmall: {
      width: '40px',
      height: '40px',
    },
    medium: {
      width: '66px',
      height: '66px',
    },
    largeAndExtraLarge: {
      width: '80px',
      height: '80px',
    },
  },
  splitViewDisplayButton: {
    left: `${splitViewRatio / 2}%`,
    extraSmallAndSmall: {
      width: '32px',
      height: '32px',
    },
    medium: {
      width: '44px',
      height: '44px',
    },
  },
});

export const getCirclePlayPauseButtonStyleObject = (playerSize: PlayerSizesTypes, clickToPlay: boolean,
  showPlayButton: boolean, showPauseButton: boolean, splitViewRatio: number, hideBlurPlayPause: boolean, showAdControls: boolean, viewDisplay: boolean): StylesObject => {
  const splitView = !isEmpty(splitViewRatio);
  const playPauseButtonStyleObject = playPauseButton(splitViewRatio);
  const extraSmallSize = playerSize === 'extraSmall';
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';
  const mediumSizeWithButton = mediumSize && (!splitView || showAdControls);
  const sizesWithCircleButton = extraSmallSize || smallSize || mediumSizeWithButton;

  return ({
    containerStyle: [
      removeHighlights,
    ],
    playButtonStyle: [
      playPauseButtonStyleObject.root,
      clickToPlay && playPauseButtonStyleObject.displayButton,
      showPlayButton && (sizesWithCircleButton || viewDisplay) && playPauseButtonStyleObject.displayButton,

      (extraSmallSize || smallSize) && playPauseButtonStyleObject.displayButton.extraSmallAndSmall,
      mediumSize && playPauseButtonStyleObject.displayButton.medium,
      (largeSize || extraLargeSize) && playPauseButtonStyleObject.displayButton.largeAndExtraLarge,

      splitView && sizesWithCircleButton && playPauseButtonStyleObject.splitViewDisplayButton,
      splitView && (extraSmallSize || smallSize) && playPauseButtonStyleObject.splitViewDisplayButton.extraSmallAndSmall,
      splitView && mediumSizeWithButton && playPauseButtonStyleObject.splitViewDisplayButton.medium,
      hideBlurPlayPause && playPauseButtonStyleObject.root,
    ],
    pauseButtonStyle: [
      playPauseButtonStyleObject.root,
      showPauseButton && (sizesWithCircleButton || viewDisplay) && playPauseButtonStyleObject.displayButton,

      (extraSmallSize || smallSize) && playPauseButtonStyleObject.displayButton.extraSmallAndSmall,
      mediumSize && playPauseButtonStyleObject.displayButton.medium,
      (largeSize || extraLargeSize) && playPauseButtonStyleObject.displayButton.largeAndExtraLarge,

      splitView && sizesWithCircleButton && playPauseButtonStyleObject.splitViewDisplayButton,
      splitView && (extraSmallSize || smallSize) && playPauseButtonStyleObject.splitViewDisplayButton.extraSmallAndSmall,
      splitView && mediumSizeWithButton && playPauseButtonStyleObject.splitViewDisplayButton.medium,
      hideBlurPlayPause && playPauseButtonStyleObject.root,
    ],
  });
};
